"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeList = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var dates_1 = __importDefault(require("../util/dates"));
var date_arithmetic_1 = __importDefault(require("../util/date-arithmetic"));
var list_1 = require("../list");
var localizers_1 = require("../util/localizers");
var custom_prop_types_1 = __importDefault(require("../util/custom-prop-types"));
var timeout_manager_1 = require("../util/timeout-manager");
var _1 = require("../util/_");
var format = function format(props) {
  return localizers_1.date.getFormat('time', props.format);
};
var TimeList = /** @class */function (_super) {
  __extends(TimeList, _super);
  function TimeList(props) {
    var _this = _super.call(this, props) || this;
    _this._isMounted = false;
    _this.setTimeout = function (key, callback, duration) {
      if (_this._isMounted) {
        return _this._timeoutManager.setTimeout(key, callback, duration);
      }
    };
    _this._closestDate = function (times, date) {
      var _a;
      var roundTo = 1000 * 60 * ((_a = _this.props) === null || _a === void 0 ? void 0 : _a.step);
      var inst = null;
      if (!date) {
        return null;
      }
      date = new Date(Math.floor(date.getTime() / roundTo) * roundTo);
      var label = localizers_1.date.format(date, format(_this.props), _this.props.locale);
      times.some(function (time) {
        if (time.label === label) {
          inst = time;
          return inst;
        }
      });
      return inst;
    };
    _this._data = function () {
      return _this.state.dates;
    };
    _this._dates = function (props) {
      var times = [];
      var values = _this._dateValues(props);
      var start = values.min;
      var startDay = date_arithmetic_1.default.getDate(start);
      while (date_arithmetic_1.default.getDate(start) === startDay && date_arithmetic_1.default.lte(start, values.max)) {
        times.push({
          date: start,
          label: localizers_1.date.format(start, format(props), props.locale)
        });
        start = date_arithmetic_1.default.add(start, props.step || 30, 'minutes');
      }
      return times;
    };
    _this._dateValues = function (props) {
      var value = props.value || props.currentDate || dates_1.default.today();
      var useDate = props.preserveDate;
      var min = props.min;
      var max = props.max;
      var start;
      var end;
      // compare just the time regradless of whether they fall on the same day
      if (!useDate) {
        start = date_arithmetic_1.default.startOf(dates_1.default.mergeTime(new Date(), min, props.currentDate), 'minutes');
        end = date_arithmetic_1.default.startOf(dates_1.default.mergeTime(new Date(), max, props.currentDate), 'minutes');
        if (date_arithmetic_1.default.lte(end, start) && date_arithmetic_1.default.gt(max, min, 'day')) {
          end = dates_1.default.tomorrow();
        }
        return {
          min: start,
          max: end
        };
      }
      start = dates_1.default.today();
      end = dates_1.default.tomorrow();
      // date parts are equal
      return {
        min: date_arithmetic_1.default.eq(value, min, 'day') ? dates_1.default.mergeTime(start, min, props.currentDate) : start,
        max: date_arithmetic_1.default.eq(value, max, 'day') ? dates_1.default.mergeTime(start, max, props.currentDate) : end
      };
    };
    _this._keyDown = function (e) {
      var key = e.key;
      var focusedItem = _this.state.focusedItem;
      var list = _this._list;
      if (key === 'End') {
        _this.setState({
          focusedItem: list.last()
        });
      } else if (key === 'Home') {
        _this.setState({
          focusedItem: list.first()
        });
      } else if (key === 'Enter') {
        if (_this.props.onSelect) {
          _this.props.onSelect(focusedItem);
        }
      } else if (key === 'ArrowDown') {
        e.preventDefault();
        _this.setState({
          focusedItem: list.next(focusedItem)
        });
      } else if (key === 'ArrowUp') {
        e.preventDefault();
        _this.setState({
          focusedItem: list.prev(focusedItem)
        });
      }
    };
    _this._keyPress = function (e) {
      _this.search(String.fromCharCode(e.which), function (item) {
        if (_this._isMounted) {
          _this.setState({
            focusedItem: item
          });
        }
      });
    };
    _this.scrollTo = function () {
      var list = _this._list;
      if (list.move) {
        list.move();
      }
    };
    _this.search = function (character, callback) {
      var word = ((_this._searchTerm || '') + character).toLowerCase();
      _this._searchTerm = word;
      _this.setTimeout('search', function () {
        var list = _this._list;
        var item = list.next(_this.state.focusedItem, word);
        _this._searchTerm = '';
        if (item) {
          callback(item);
        }
      }, _this.props.delay);
    };
    var data = _this._dates(_this.props);
    var focusedItem = _this._closestDate(data, props.value);
    _this.state = {
      focusedItem: focusedItem || data[0],
      dates: data
    };
    _this._timeoutManager = new timeout_manager_1.TimeoutManager();
    return _this;
  }
  TimeList.prototype.componentDidMount = function () {
    this._isMounted = true;
  };
  TimeList.prototype.componentWillReceiveProps = function (nextProps) {
    var data = this._dates(nextProps);
    var focusedItem = this._closestDate(data, nextProps.value);
    var valChanged = nextProps.value !== undefined && this.props.value !== undefined ? !date_arithmetic_1.default.eq(nextProps.value, this.props.value, 'minutes') : nextProps.value !== this.props.value;
    var minChanged = !date_arithmetic_1.default.eq(nextProps.min, this.props.min, 'minutes');
    var maxChanged = !date_arithmetic_1.default.eq(nextProps.max, this.props.max, 'minutes');
    var localeChanged = this.props.format !== nextProps.format || this.props.locale !== nextProps.locale;
    if (valChanged || minChanged || maxChanged || localeChanged) {
      this.setState({
        focusedItem: focusedItem || data[0],
        dates: data
      });
    }
  };
  TimeList.prototype.componentWillUnmount = function () {
    this._isMounted = false;
    this._timeoutManager.clearAllTimeouts();
  };
  TimeList.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      value = _a.value,
      onSelect = _a.onSelect,
      onMove = _a.onMove;
    var times = this.state.dates;
    var date = this._closestDate(times, value);
    return react_1.default.createElement(list_1.List, __assign({}, _1.omitOwnProps(this), {
      ref: function ref(c) {
        _this._list = c;
      },
      data: times,
      textField: "label",
      valueField: "date",
      selected: date,
      onSelect: onSelect,
      focused: this.state.focusedItem,
      onMove: onMove,
      onAriaActiveDescendant: this.props.onAriaActiveDescendant
    }));
  };
  TimeList.propTypes = {
    value: prop_types_1.default.instanceOf(Date),
    min: prop_types_1.default.instanceOf(Date),
    max: prop_types_1.default.instanceOf(Date),
    currentDate: prop_types_1.default.instanceOf(Date),
    step: prop_types_1.default.number,
    itemComponent: custom_prop_types_1.default.elementType,
    format: prop_types_1.default.any,
    onSelect: prop_types_1.default.func,
    preserveDate: prop_types_1.default.bool,
    locale: prop_types_1.default.string,
    delay: prop_types_1.default.number,
    onMove: prop_types_1.default.func
  };
  TimeList.defaultProps = {
    step: 30,
    onSelect: function onSelect() {},
    min: new Date(1900, 0, 1),
    max: new Date(2099, 11, 31),
    preserveDate: true,
    delay: 300
  };
  return TimeList;
}(react_1.default.Component);
exports.TimeList = TimeList;